import { Button } from '@mui/material';
import { styled } from 'styled-components';

export const RoundedButton = styled(Button).attrs((props: any) => ({
  variant: 'contained',
  color: 'primary',
  style: {
    backgroundColor: props.backgroundColor,
    color: props.textColor
  }
}))<{
  backgroundColor?: string;
  textColor?: string;
}>({
  width: '100%',
  maxWidth: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto',
    maxWidth: '200px'
  },
  textWrap: 'nowrap'
});
